import { render, staticRenderFns } from "./DriverInformations.vue?vue&type=template&id=142bbad0&scoped=true"
import script from "./DriverInformations.vue?vue&type=script&lang=js"
export * from "./DriverInformations.vue?vue&type=script&lang=js"
import style0 from "./DriverInformations.vue?vue&type=style&index=0&id=142bbad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142bbad0",
  null
  
)

export default component.exports